import "../style.scss";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import type { CSSProperties } from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

import variables from "../../../../assets/styles/_variables.module.scss";

export interface RadioFormOption {
    label: string;
    defaultChecked?: boolean;
    extraComponent?: JSX.Element;
    hide?: boolean;
    description?: string;
}

interface RadioFormComponentProps {
    label: string;
    labelDescription?: string;
    options: RadioFormOption[];
    placeholder?: string;
    control: any;
    controlName: string;
    error?: any;
    required?: boolean;
    disabled?: boolean;
    /** this props apply a style on label to show radio in line */
    labelAligned?: boolean;
    column?: boolean;
    id?: string;
    style?: CSSProperties;
    onValueChange?: (value: string) => void;
}

const RadioFormComponent = (props: RadioFormComponentProps) => {
    const {
        label,
        labelDescription,
        options,
        placeholder,
        control,
        controlName,
        error,
        required,
        disabled,
        labelAligned = false,
        column = false,
        id,
        style = {},
        onValueChange,
    } = props;
    const [t] = useTranslation();

    const _style = labelAligned
        ? {
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              ...style,
          }
        : style;

    return (
        <div className="form-component" style={_style}>
            <Controller
                name={controlName}
                control={control}
                rules={{
                    required: required ? t("NewElement.Required") : undefined,
                }}
                render={({ field: { onChange, ...field } }) => {
                    return (
                        <>
                            <label className="form-component-label" htmlFor={controlName}>
                                {label}
                                {required && "*"}
                            </label>
                            {labelDescription && <span className="label-description">{labelDescription}</span>}
                            <RadioGroup
                                {...field}
                                id={id}
                                name={controlName}
                                row={!column}
                                defaultValue={`${options.findIndex((opt) => opt.defaultChecked)}`}
                                sx={{ paddingLeft: "4px" }}
                                onChange={(event) => {
                                    onChange(event);
                                    onValueChange?.(event.target.value);
                                }}
                            >
                                {options &&
                                    options.map(
                                        (opt, index) =>
                                            !opt.hide && (
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        marginBottom: opt.extraComponent ? "10px" : "Opx",
                                                    }}
                                                    key={`option-${index}`}
                                                >
                                                    <FormControlLabel
                                                        id={`${id}-${index}`}
                                                        value={`${index}`}
                                                        control={
                                                            <Radio checkedIcon={<CheckCircleIcon width={"15px"} />} />
                                                        }
                                                        disabled={disabled}
                                                        label={opt.label}
                                                    />
                                                    <span
                                                        style={{
                                                            fontSize: "12px",
                                                            fontWeight: "400",
                                                            color: variables["foreground"],
                                                            lineHeight: "20px",
                                                            marginLeft: "19px",
                                                            marginTop: "-5px",
                                                        }}
                                                    >
                                                        {opt.description}
                                                    </span>
                                                    {+field.value === index && opt.extraComponent}
                                                </div>
                                            ),
                                    )}
                            </RadioGroup>
                        </>
                    );
                }}
            />
        </div>
    );
};

export default RadioFormComponent;
